import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    EMERGENCY_DTRF,
    saveEmergencyDtrfFail,
    saveEmergencyDtrfSuccess
} from '../action/saveEmergencyDtrfAction'

// api 
import saveEmergencyDtrfApi from '../api/saveEmergencyDtrfApi'

export function* saveEmergencyDtrfSaga(action) {
    try {
        const response = yield call(() => saveEmergencyDtrfApi(action.params))
        if (response.data.status === 1) {
            yield put(saveEmergencyDtrfSuccess(response, action))
        } else {
            yield put(saveEmergencyDtrfFail(response, action))
        }
    }
    catch (e) {
        yield put(saveEmergencyDtrfFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(EMERGENCY_DTRF, saveEmergencyDtrfSaga)
}